import building from '../assets/building.png';
import group from '../assets/group.png';
import flat from '../assets/flat.png';
import announce from '../assets/announce.svg';

import history from '../assets/history.png';
import complaint from '../assets/complaint.png';
import contact  from '../assets/contact.png';
import directory from '../assets/directory.png';
import gate from '../assets/gate.png';
import bills from '../assets/bills.png';


const images={
    building,
    flat,
    group,
    announce,
    gate,
    complaint,
    history,
    contact,
    bills,
    directory
}
 export default  images;